import { FC } from 'react';

import { Stack, Typography } from '@mui/material';
import { MobileViewDrawer } from 'portfolio3/components/drawers';
import { Button } from 'portfolio3/ui-kit/button';

import * as styles from './styles';

interface IProforientationResultsDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  onAction: () => void;
}

const ProforientationResultsDrawer: FC<IProforientationResultsDrawerProps> = ({ isOpen, onClose, onAction }) => {
  const bodyElement = (
    <Stack gap="12px">
      <Typography variant="Headings/H5">Готовы результаты профориентации!</Typography>
      <Typography variant="Paragraph LG/Regular">Ознакомься с результатами и скачай их</Typography>
    </Stack>
  );

  const closeButtonElement = (
    <Button size="large" sx={styles.button} variant="tetriary" onClick={onClose}>
      Закрыть
    </Button>
  );

  const actionButtonElement = (
    <Button size="large" sx={styles.button} onClick={onAction}>
      Перейти к результатам
    </Button>
  );

  return (
    <MobileViewDrawer title="" open={isOpen} onClose={onClose}>
      <Stack gap="24px">
        {bodyElement}
        <Stack gap="8px">
          {actionButtonElement}
          {closeButtonElement}
        </Stack>
      </Stack>
    </MobileViewDrawer>
  );
};

export default ProforientationResultsDrawer;
